import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import "antd/dist/reset.css";
import { BrowserRouter } from "react-router-dom";
import AppProvider from './AppProvider.jsx';
import { HelmetProvider } from 'react-helmet-async';

createRoot(document.getElementById('root')).render(
  <BrowserRouter>
  <StrictMode>
      <HelmetProvider>
    <AppProvider>
    <App />
    </AppProvider>
    </HelmetProvider>
  </StrictMode>
  </BrowserRouter>,
)
